import { pdfjs } from 'react-pdf';

// Initialize the PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

// Export a function to make sure the worker is initialized
export const initPdfWorker = () => {
  // Worker is already initialized through the above code
  return pdfjs.version;
};
